<template>
  <div class="agreement">
    <div class="title">粤桥工科通行证注册协议</div>
    <p>《粤桥工科通行证注册协议》（以下简称“本协议”）是由广州粤桥工程咨询有限公司（以下简称“粤桥工科”）与您（包含注册、登录、使用、浏览粤桥工科软件产品、服务的个人或组织）之间所订立的协议。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。申请人应当认真阅读、充分理解本协议中各条款, 包括免除或者限制鲁班软件责任的免责条款及对用户的权利限制条款。审慎阅读并选择接受或不接受本协议。</p><br />
    <p>粤桥工科软件有权对本协议包含的条款随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，您可在本网站查阅最新版协议条款。在粤桥工科软件修改本协议相关条款之后，若您不接受修改后的条款，请停止使用粤桥工科软件提供的产品和服务，继续使用粤桥工科软件提供的产品和服务将被视为您已接受了修改后的协议。</p><br /><br />
    <h4>1 注册与账号</h4><br />
    <p>1.1 粤桥工科通行证的所有权归粤桥工科软件，您完成注册手续后，获得粤桥工科通行证的使用权。您应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。</p><br />
    <p>1.2 您须对注册信息的有效性、真实性、合法性、承担全部责任；不得恶意使用注册账号导致其他用户误认；不得冒充他人，不得利用、冒用他人的名义发布任何信息；否则粤桥工科软件有权回收该粤桥工科通行证，由您独自承担由此而产生的一切法律责任。</p><br />
    <p>1.3 您使用粤桥工科软件产品、服务的行为必须合法，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何结果。粤桥工科软件无法且不会对因您行为而导致的任何损失或损害承担责任。</p><br />
    <p>1.4 您须对自己的登录信息保密，您必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知粤桥工科软件，粤桥工科软件不对您因未能遵守上述要求而造成的损失承担责任。</p><br />
    <p>1.5 您不应将您的账号、密码出租或出让予他人使用，若您授权他人使用粤桥工科通行证，应对被授权人在该粤桥工科通行证下发生所有行为负全部责任。</p><br /><br />
    <h4>2 服务内容</h4><br />
    <p>2.1 粤桥工科软件产品服务的具体内容由鲁班软件根据实际情况提供。</p><br />
    <p>2.2 除非本服务协议另有其它明示规定，粤桥工科软件所推出的产品、功能、服务，均受到本服务协议之规范。</p><br />
    <p>2.3 粤桥工科软件需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，粤桥工科软件无需为此承担任何责任。粤桥工科软件保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。</p><br />
    <p>2.4 您明确同意您使用粤桥工科软件产品和服务所存在的风险将完全由您自己承担。您理解并接受下载或通过粤桥工科软件服务取得的任何信息资料取决于您自己，并由您承担系统受损、资料丢失以及其它任何风险，粤桥工科软件不作担保。</p><br />
    <p>2.5 粤桥工科软件仅提供相关的网络服务, 除此之外与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费)均应由用户自行负担。</p><br />
    <p>2.6 粤桥工科软件有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，粤桥工科软件对您和任何第三人均无需承担任何责任。</p><br /><br />
    <h4>3 权利限制</h4><br />
    <p>3.1 用户不得以创建相同或竞争服务为目的访问或使用粤桥工科通行证。</p><br />
    <p>3.2 用户不得对粤桥工科通行证进行任何形式的出售、租赁、转让或做其他商业用途。</p><br />
    <p>3.3 用户在注册和使用粤桥工科通行证的过程中, 必须遵循国家的相关法律法规, 不得发布危害国家安全、色情、暴力、侵犯版权等任何合法权利等非法内容; 也不得利用本账号发布含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、或其它道德上令人反感的内容。如发现用户帐号中含有不雅文字或不恰当名称的, 粤桥工科软件保留注销其用户帐号的权利。</p><br />
    <p>3.4 用户有义务保证密码和帐号的安全, 用户利用该帐号所进行的一切活动引起的任何损失或损害, 由用户自行承担全部责任, 粤桥工科软件不承担任何责任。如用户发现帐号遭到未授权的使用或发生其他任何安全问题, 应立即修改账号密码并妥善保管。因黑客行为或用户的保管疏忽导致帐号非法使用, 粤桥工科软件不承担任何责任。</p><br />
    <p>3.5 用户帐号独占使用权仅属于初始申请注册人。为避免因账号问题产生纠纷, 用户不应私下有偿、无偿转让或出赁帐号, 用户应当自行承担因违反此要求而遭致的任何损失。</p><br /><br />
    <h4>4 风险与免责</h4><br />
    <p>基于互联网的开放性和特殊性，粤桥工科软件特别提醒您谨慎注意以下风险：</p><br />
    <p>4.1 本账号仅用于登陆粤桥工科软件产品、程序、服务，您应当对其他用户使用本账号所产生的信息进行独立判断并承担因依赖该内容而引起的所有风险，包括但不限于因对内容的正确性、完整性或实用性的依赖而产生的风险以及因用户个人信息被其他用户获知而带来的风险。您了解并确认，粤桥工科软件不对本服务用户之间的纠纷承担任何责任。</p><br />
    <p>4.2 请您切勿在使用本账号时透露任何涉及财产、本服务账号及密码等重要信息，否则，由此带来的损失由您自行承担。</p><br />
    <p>4.3 由于您或其他用户违反本账号相关规则导致被粤桥工科软件依约处理的，可能会对您在本账号中的内容、信息等数据造成影响。</p><br /><br />
    <h4>5 第三方产品和服务</h4><br />
    <p>5.1 本账号可能用于第三方提供的产品或服务。当用户使用第三方提供的产品或服务时，可能会另有相关的协议或规则，您同样应当认真阅读并遵守。</p><br />
    <p>5.2 您须理解并同意：为了向您提供更好的用户体验，当您在使用第三方服务时，第三方可能会接触、使用到您的昵称、头像以及在第三方服务中的相关操作信息等信息。</p><br />
    <p>5.3 如您在使用第三方产品或服务时发生任何纠纷的，请与第三方直接联系，粤桥工科软件不承担任何责任，但根据需要会依法提供必要的协助。</p><br /><br />
    <p>本协议以中华人民共和国法律为准。</p><br />
    <p>若您就本协议有任何疑问，或您因任何事情拟洽询本公司时，请函洽：广州粤桥工程咨询有限公司</p><br />
    <p>广州粤桥工程咨询有限公司</p><br />
    <p>地址：广州中新广州知识城九龙大道腾飞一街2号1019室</p><br />
    <p>邮编：510663</p><br />
    <p>电话总机：020-xxxxxxxx</p><br />
    <!-- <p>传真：</p><br /> -->
    <!-- <p>服务投诉：</p><br /> -->
    <p>网站：www.yueq.com.cn</p><br />
    <p>邮箱：xxxxxxxx@yueq.com</p><br />
  </div>
</template>
<script>
export default {
  name: 'agreement'
}
</script>
<style lang="less" scoped>
.agreement {
  display: block;
  width: 100%;
  max-width: 1200px;
  padding: 0 32px;
  margin: 32px auto;
  color: #000;
  font-size: 14px;
  line-height: 1.5em;
  .title {
    width: 100%;
    margin: 54px 0;
    text-align: center;
    position: relative;
    font-size: 36px;
    line-height: 1.5em;
    font-weight: bold;
  }
  .title::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 8px;
    background-color: #1677ff;
  }
}
</style>
